import { useIsSiteAdmin } from '@confluence/current-user/entry-points/useIsSiteAdmin.ts';

/**
 * Analytics split for Try JPD clicks.
 *
 * Confluence `isSiteAdmin` is true for site admins and org admins (org admins
 * are treated as site admins on the product). Both are tagged CAN_CREATE_SPACE;
 * everyone else is EVALUATION_REQUEST. Loading or a failed admin check is UNKNOWN.
 */
export const JPD_ACCESS_CAPABILITY = {
	CAN_CREATE_SPACE: 'CAN_CREATE_SPACE',
	EVALUATION_REQUEST: 'EVALUATION_REQUEST',
	UNKNOWN: 'UNKNOWN',
} as const;

export type JpdAccessCapability =
	(typeof JPD_ACCESS_CAPABILITY)[keyof typeof JPD_ACCESS_CAPABILITY];

export const useJpdAccessCapability = (): JpdAccessCapability => {
	const { isSiteAdmin, isAdminCheckLoading, isError } = useIsSiteAdmin();

	if (isAdminCheckLoading || isError) {
		return JPD_ACCESS_CAPABILITY.UNKNOWN;
	}

	return isSiteAdmin
		? JPD_ACCESS_CAPABILITY.CAN_CREATE_SPACE
		: JPD_ACCESS_CAPABILITY.EVALUATION_REQUEST;
};
